import { useAppSelector } from "store/hooks";
import style from "./TableBody.module.scss";
import { RiLoader5Fill } from "react-icons/ri";
import { useGetUserProxiesQuery } from "@RTKQuery/admin/customers/customers";
import { useParams } from "react-router-dom";
import { IUserProxy } from "@interfaces/admin/userProxy";

export function TableBody({
    children
}: {
    children: (data: IUserProxy) => JSX.Element
}) {
    const { id } = useParams();

    const { activePaginationLimit, activePaginationPage } = useAppSelector(state => state.customerProxyAdminPage);

    const { currentData: data, isFetching } = useGetUserProxiesQuery({
        limit: activePaginationLimit,
        page: activePaginationPage,
        user_id: Number(id)
    }, {
        pollingInterval: 5000,
        refetchOnMountOrArgChange: true,
        refetchOnFocus: true,
        refetchOnReconnect: true,
        skipPollingIfUnfocused: true
    });

    return (
        <div className={style.body}>
            {
                isFetching && !data
                    ? <div className={style.empty}><RiLoader5Fill className="animate-spin w-[30px] h-[30px]" /></div>
                    : data?.purchases.map(row => children(row))
            }
        </div>
    )
}

